/**
 * Image-export helpers built on top of ``html-to-image``.
 *
 * Use ``exportNodeToPng(node, filename)`` to convert any DOM node into a
 * downloaded PNG. The Web Share API is preferred when available so users
 * on mobile can post directly to WhatsApp/IG instead of going through the
 * file system. Falls back to a plain anchor download.
 */
import { toPng } from "html-to-image";

const FILTER_SCRIPTS = (node) => {
  // Skip <script> tags; everything else (style, svg, img, gradient) renders.
  return node.tagName !== "SCRIPT";
};

export async function exportNodeToPng(node, filename = "bet-cracker.png") {
  if (!node) return false;
  // Wait one paint frame so React-driven children settle their layout.
  await new Promise((r) => requestAnimationFrame(r));
  const dataUrl = await toPng(node, {
    cacheBust: true,
    pixelRatio: 2,                 // crisp on retina + IG
    backgroundColor: "#020202",    // the app's actual canvas
    filter: FILTER_SCRIPTS,
    skipFonts: false,
  });

  // Try the Web Share API first (mobile-friendly).
  try {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], filename, { type: "image/png" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: "Bet Cracker" });
      return true;
    }
  } catch {
    // user dismissed or not supported — fall through to download
  }

  // Fallback: direct download.
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  return true;
}
